import { ReactNode } from 'react'
import { IconButton, Tooltip } from '@mui/material'
import { fieldsStyles as styles } from 'src/components/shared/ui/form/fields/fieldsStyles'

type Props = {
  children: ReactNode
  disabled?: boolean
  title: string
  handleClick?: () => any
  placement?:
    | 'bottom-end'
    | 'bottom-start'
    | 'bottom'
    | 'left-end'
    | 'left-start'
    | 'left'
    | 'right-end'
    | 'right-start'
    | 'right'
    | 'top-end'
    | 'top-start'
    | 'top'
}

function LexnetIconButton({
  children,
  disabled = false,
  placement = 'top',
  title,
  handleClick
}: Props): JSX.Element {
  if (disabled) {
    return (
      <IconButton disabled={disabled} aria-label={title} sx={styles.icon}>
        {children}
      </IconButton>
    )
  }

  return (
    <Tooltip title={title} placement={placement} componentsProps={styles} arrow>
      <IconButton disabled={disabled} onClick={handleClick} aria-label={title}>
        {children}
      </IconButton>
    </Tooltip>
  )
}

export default LexnetIconButton
